<div>
  <div class="top-corner">
    <h3>
      Templates de job
    </h3>
    <button mat-button class="cta-button" (click)="addNewRow()"><mat-icon>add</mat-icon>Nouveau</button>

  </div>

  <div class="mat-elevation-z8" >

    <mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="id">
        <mat-header-cell *matHeaderCellDef mat-sort-header> ID </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.id}} </mat-cell>

      </ng-container>

      <ng-container matColumnDef="code">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Code </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span [hidden]="(editingItem && element.id===editingItemId)">{{element.code}}</span>
          <input [hidden]="!(editingItem && element.id===editingItemId)" matInput [(ngModel)]="editedItem.code"
            placeholder="Code" >
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="title">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Nom </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span [hidden]="(editingItem && element.id===editingItemId)">{{element.title}}</span>
            <input [hidden]="!(editingItem && element.id===editingItemId)" matInput [(ngModel)]="editedItem.title"
              placeholder="Titre" >
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="category">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Groupe </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <span [hidden]="(editingItem && element.id===editingItemId)">{{element.category}}</span>

              @if ((editingItem && element.id===editingItemId)) {
                <mat-select matInput name="category" [(ngModel)]="editedItem.category" placeholder="Catégorie">
                  @for (item of jobCategories; track item) {
                    <mat-option [value]="item.code" >{{item.title}}</mat-option>
                  }
                </mat-select>
              }
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="tasks">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Tasks </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <span [hidden]="(editingItem && element.id===editingItemId)">

                @for (task of element.tasks; track task; let i = $index) {
                  <h6>
                    {{i+1}} - {{task.category}} : {{task.title}}
                  </h6>
                }

              </span>

              @if ((editingItem && element.id===editingItemId)) {
                <mat-select multiple matInput name="tasks" [(ngModel)]="editedItem.tasks" placeholder="Tasks">
                  @for (item of jobTasks; track item) {
                    <mat-option [value]="item" >{{item.title}}</mat-option>
                  }
                </mat-select>
              }
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="lastUpdated">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Modifié le </mat-header-cell>
            <mat-cell *matCellDef="let element" > {{dateTimeFormat(element.lastUpdated)}} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Actions </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <button mat-button class="simple-button" (click)="editItem(element.id)" [hidden]="(editingItem && element.id===editingItemId)"><mat-icon>edit</mat-icon></button>
              <button mat-button class="simple-button" (click)="saveItem(element.id)" [hidden]="!(editingItem && element.id===editingItemId)" [disabled]="!editedItemIsValid()">
                <mat-icon>save</mat-icon>
              </button>
              <button mat-button class="simple-button" (click)="deleteItem(element.id)"><mat-icon>{{editingItem && element.id===editingItemId ? 'undo' : 'delete'}}</mat-icon>{{editingItem && element.id===editingItemId ? '' : ''}}</button>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

        </mat-table>

        <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
      </div>

    </div>

